<template>
  <div
    id="floatDoAns"
    :style="isFull ? fullConfig : config"
    v-show="show"
  >
    <div
      class="popup-title"
      @mousedown="headMouseDown"
    >
      <div class="title-but">
        <button
          class="full-but"
          :class="isFull ? 'full-exit' : ''"
          @click="fullPopUp"
        ></button>
        <button
          class="close-but"
          @click="closePopUp"
        ></button>
      </div>
    </div>
    <div class="popup-main">
      <doanswer
        v-if="show"
        ref="doanswer"
        :is_full.sync="is_full"
        :is_float="true"
        :curySkin="curySkin"
        :topic="topic"
        :cur_question_id="cur_question_id"
        @cancleFloat="cancleFloat"
        @fullScreen="fullScreen"
      ></doanswer>
    </div>
    <div
      class="popup-right-resize"
      @mousedown="rightResize"
    ></div>
    <div
      class="popup-bottom-resize"
      @mousedown="bottomResize"
    ></div>
  </div>
</template>
<script>
import Doanswer from "@/components/paper/doanswer"

export default {
  name: "floatDoAns",
  components: { Doanswer },
  data () {
    return {
      isFull: false,
      show: false,
      config: {
        width: '80%',
        height: 'calc(100% - 150px)',
        top: '120px',
        left: '10%'
      },
      fullConfig: {
        width: '100%',
        height: 'calc(100% - 86px)',
        top: '86px',
        left: '0'
      }
    }
  },
  props: {
    is_show: Boolean,
    curySkin: String,
    topic: Object,
    cur_question_id: String,
    is_full: Boolean
  },
  watch: {
    is_show (newVal) {
      this.show = newVal;
    }
  },
  created () {
  },
  methods: {
    headMouseDown () {
      document.body.style.userSelect = 'none';
      const dragDom = document.querySelector('#floatDoAns');
      // dragDom.style.cssText += 'left:10%;top:120px;';
      // el.style.cssText += ';transform-origin:50% 50%';

      // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
      const sty = (function () {
        if (window.document.currentStyle) {
          return (dom, attr) => dom.currentStyle[attr];
        } else {
          return (dom, attr) => getComputedStyle(dom, false)[attr];
        }
      })();
      const _this = this;
      dragDom.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX
        const disY = e.clientY

        const screenWidth = document.body.clientWidth; // body当前宽度
        const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)

        // const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
        // const dragDomheight = dragDom.offsetHeight; // 对话框高度

        const minDragDomLeft = disX - 36;
        const maxDragDomLeft = screenWidth - dragDom.offsetLeft - 36;

        const minDragDomTop = dragDom.offsetTop;
        const maxDragDomTop = screenHeight - dragDom.offsetTop - 36;

        // 获取到的值带px 正则匹配替换
        let styL = sty(dragDom, 'left');
        let styT = sty(dragDom, 'top');
        // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
        if (styL.includes('%')) {
          styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100);
          styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100);
        } else {
          styL = +styL.replace(/\px/g, '');
          styT = +styT.replace(/\px/g, '');
        }

        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let left = e.clientX - disX;
          let top = e.clientY - disY;

          // 边界处理
          if (-(left) > minDragDomLeft) {
            left = -(minDragDomLeft);
          } else if (left > maxDragDomLeft) {
            left = maxDragDomLeft;
          }

          if (-(top) > minDragDomTop) {
            top = -(minDragDomTop);
          } else if (top > maxDragDomTop) {
            top = maxDragDomTop;
          }

          // 移动当前元素
          _this.config.left = `${left + styL}px`;
          _this.config.top = `${top + styT}px`;
        };

        document.onmouseup = function () {
          dragDom.onmousedown = null;
          document.onmousemove = null;
          document.onmouseup = null;
          document.body.style.userSelect = 'initial';
        };
      };
    },
    rightResize () {
      document.body.style.userSelect = 'none';
      const dragDom = document.querySelector('#floatDoAns');
      const _this = this;
      dragDom.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX
        const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let left = e.clientX - disX;

          // 移动当前元素
          _this.config.width = `${dragDomWidth + left}px`;
        };
        document.onmouseup = function () {
          dragDom.onmousedown = null;
          document.onmousemove = null;
          document.onmouseup = null;
          document.body.style.userSelect = 'initial';
        };
      };
    },
    bottomResize () {
      document.body.style.userSelect = 'none';
      const dragDom = document.querySelector('#floatDoAns');
      const _this = this;
      dragDom.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disY = e.clientY
        const dragDomheight = dragDom.offsetHeight; // 对话框高度        
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let top = e.clientY - disY;

          // 移动当前元素
          _this.config.height = `${dragDomheight + top}px`;
        }
      };
      document.onmouseup = function () {
        dragDom.onmousedown = null;
        document.onmousemove = null;
        document.onmouseup = null;
        document.body.style.userSelect = 'initial';
      };
    },
    closePopUp () {
      this.show = false;
      this.$emit('update:is_show', false);
    },
    fullPopUp () {
      this.isFull = !this.isFull;
    },
    cancleFloat () {
      this.$emit('cancleFloat');
    },
    fullScreen (isFull) {
      this.$emit('fullScreen', isFull);
    }
  }
}
</script>
<style lang="scss" scoped>
#floatDoAns {
  position: absolute;
  z-index: 999999;
  width: 80%;
  height: calc(100% - 150px);
  top: 120px;
  left: 10%;
  border-radius: 4px;
  box-shadow: 0 1px 4px #333;
  background-color: #ffffff;
  .popup-title {
    height: 16px;
    padding: 10px;
    background-color: #218cfc;
    border-radius: 4px 4px 0 0;
    cursor: all-scroll;
    .title-but {
      float: right;
      button {
        width: 20px;
        height: 20px;
        outline: 0;
        border: none;
        cursor: pointer;
      }
      .full-but {
        background: url(../../assets/image/exam/max-01-default.png);
        background-size: cover;
        &:hover {
          background: url(../../assets/image/exam/max-02-hover.png);
          background-size: cover;
        }
        &:active {
          background: url(../../assets/image/exam/max-03-click.png);
          background-size: cover;
        }
        &.full-exit {
          background: url(../../assets/image/exam/restore-01-default.png);
          background-size: cover;
          &:hover {
            background: url(../../assets/image/exam/restore-02-hover.png);
            background-size: cover;
          }
          &:active {
            background: url(../../assets/image/exam/restore-03-click.png);
            background-size: cover;
          }
        }
      }
      .close-but {
        background: url(../../assets/image/exam/close-01-default.png);
        background-size: cover;
        &:hover {
          background: url(../../assets/image/exam/close-02-hover.png);
          background-size: cover;
        }
        &:active {
          background: url(../../assets/image/exam/close-03-click.png);
          background-size: cover;
        }
      }
    }
  }
  .popup-main {
    margin-right: 4px;
    height: calc(100% - 40px);
  }
  .popup-right-resize {
    width: 4px;
    height: calc(100% - 40px);
    background-color: transparent;
    position: absolute;
    top: 36px;
    right: 0;
    cursor: col-resize;
  }
  .popup-bottom-resize {
    width: 100%;
    height: 4px;
    background-color: transparent;
    cursor: row-resize;
  }
}
</style>
<style>
.full {
  position: relative;
  overflow: hidden;
}
</style>